// extracted by mini-css-extract-plugin
export default {"image":"NewFeature_image__pqwSE","alert":"NewFeature_alert__5fTLj"};